module.exports = __webpack_public_path__ + "static/media/clue_sound.eb782f68.wav";